import React from 'react';

export const SettingIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <title id="-Ty7NTaqihRW6GB9-YIKB-title">settings</title>
      <g clipPath="url(#Settings__clip0)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M22.084 14.489l.96.793c.456.37.578 1.016.288 1.528l-1.392 2.404a1.199 1.199 0 01-1.38.517l-1.2-.433a2.396 2.396 0 00-2.136.229 6.562 6.562 0 01-.888.517 2.405 2.405 0 00-1.272 1.744l-.204 1.202a1.2 1.2 0 01-1.2 1.01H10.9a1.2 1.2 0 01-1.2-1.01l-.204-1.202a2.404 2.404 0 00-1.272-1.744 6.562 6.562 0 01-.888-.517 2.396 2.396 0 00-2.136-.229l-1.2.433a1.199 1.199 0 01-1.452-.517L1.156 16.81a1.204 1.204 0 01.288-1.527l.96-.794a2.407 2.407 0 00.864-1.972v-1.034a2.407 2.407 0 00-.864-1.972l-.96-.794a1.204 1.204 0 01-.288-1.527l1.392-2.404c.293-.49.89-.707 1.428-.517l1.2.432c.708.266 1.5.181 2.136-.228.282-.195.58-.368.888-.517a2.405 2.405 0 001.224-1.743l.204-1.203a1.2 1.2 0 011.2-1.01h2.76a1.2 1.2 0 011.2 1.01l.204 1.203c.125.75.597 1.396 1.272 1.743.31.149.606.322.888.517a2.396 2.396 0 002.136.228l1.2-.432a1.199 1.199 0 011.452.517l1.392 2.404c.29.512.168 1.157-.288 1.527l-.96.794a2.407 2.407 0 00-.864 1.972v1.034a2.407 2.407 0 00.864 1.972zM8.644 12a3.604 3.604 0 003.6 3.607c.955 0 1.87-.38 2.546-1.056A3.61 3.61 0 0015.844 12a3.604 3.604 0 00-3.6-3.607A3.604 3.604 0 008.644 12z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="Settings__clip0">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
